/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    value6: "",
    value7: "",
    value8: "",
    value9a: "",
    value9: "",
    value10: false,
    value11: "",
    value12: "",
    value13: "",
    value14: "",
    value15: "",
    value16: "",
  },
];

function TaxPersonalTable04({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value6: "",
      value7: "",
      value8: "",
      value9a: "",
      value9: "",
      value10: false,
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
    };

    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", background: "#f4f4f4" }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Họ và tên
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã số thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Loại giấy tờ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số CMND/CCCD/Hộ Chiếu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Cá nhân không cư trú
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Thu nhập chịu thuế (TNCT)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Trong đó: thu nhập thuế được miễn theo Hiệp định
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Trong đó TN chịu thuế được miễn theo quy định của Hợp đồng dầu khí
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số thuế thu nhập cá nhân (TNCN) đã khấu trừ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Trong đó: TNCT từ phí mua BH nhân thọ, BH không bắt buộc khác của DN BH không thành
                lập tại Việt Nam cho người lao động
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Trong đó: số thuế từ phí mua BH nhân thọ, BH không bắt buộc khác của DN BH không
                thành lập tại Việt Nam cho người lao động
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [06]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [07]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [08]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [09a]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [09]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [10]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [11]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [12]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [13]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [14]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [15]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [16]
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={({ target: { value } }) =>
                      handleChange({ id: item.id, value, name: "value9a" })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    type="text"
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <Switch
                    checked={item.value10}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value10" })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value14"
                    value={item.value14}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value15"
                    value={item.value15}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td rowSpan={1} colSpan={6} style={{ textAlign: "center", background: "#ddeff3" }}>
                Tổng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
          (BH: Bảo hiểm; DN: Doanh nghiệp; CMND:Chứng minh nhân dân; CCCD: Căn cước công dân)
        </Typography>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

export default memo(TaxPersonalTable04);

function InputTable(props) {
  const { id, onChange, type, name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type && type === "text") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        minWidth: 100,
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
